import { selector } from '@/pages/CompanyReport/components/Valuation';
import { useSelector, shallowEqual } from 'react-redux';
import Tooltip from '@/components/Tooltip';
import { Table } from './styled';
import useGlossaryTerms from '@/hooks/useGlossaryTerms';
import { TipContainer, Term } from '../KeyMetricsChart/styled';
import DocumentSchema from '@/components/DocumentSchema';
import type { Table as TableSchema } from 'schema-dts';

export const KeyMetricsOthers = () => {
  const selected = useSelector<
    Parameters<typeof selector>[0],
    ReturnType<typeof selector>
  >(selector, shallowEqual);

  const getTerm = useGlossaryTerms();
  const pegTerm = getTerm('peg ratio');
  const header = 'Key Statistics';
  const caption = `${selected.tickerSymbol} key valuation metrics and ratios. From Price to Earnings, Price to Sales and Price to Book to Price to Earnings Growth Ratio, Enterprise Value and EBITDA.`;
  return (
    <>
      <DocumentSchema<TableSchema>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Table',
          headline: header,
          about: caption,
        }}
      />
      <Table data-cy-id="key-metrics-others-table">
        <caption>{caption}</caption>
        <thead>
          <tr>
            <th colSpan={2}>{header}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Tooltip
                title={<TipContainer>Enterprise Value/Revenue</TipContainer>}
                light
                openDelay={300}
              >
                <Term>Enterprise Value/Revenue</Term>
              </Tooltip>
            </td>
            <td>{selected.valueRevenueRatio}</td>
          </tr>
          <tr>
            <td>
              <Tooltip
                title={<TipContainer>Enterprise Value/EBITDA</TipContainer>}
                light
                openDelay={300}
              >
                <Term>Enterprise Value/EBITDA</Term>
              </Tooltip>
            </td>
            <td>{selected.valueEbitdaRatio}</td>
          </tr>
          <tr>
            <td>
              <Tooltip
                title={<TipContainer>{pegTerm}</TipContainer>}
                light
                openDelay={300}
              >
                <Term>PEG Ratio</Term>
              </Tooltip>
            </td>
            <td>{selected.PEG}</td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};
